import { useDictionary } from '../../../hooks/useDictionary/useDictionary';
import DumbErrorSummaryAtom from './ErrorSummaryAtom.dumb';

/* ---------------------------------- Types --------------------------------- */

export interface ErrorSummaryAtomI {
    /** An object containing errors to display */
    errors: Record<string, string | undefined>;
}

/* -------------------------------- Component ------------------------------- */

const ErrorSummaryAtom = ({ errors }: ErrorSummaryAtomI) => {
    const dictionary = useDictionary();

    return <DumbErrorSummaryAtom errors={errors} dictionary={dictionary} />;
};

/* --------------------------------- Export --------------------------------- */

export default ErrorSummaryAtom;
